"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDefinitions = void 0;
const index_1 = require("../../Model/index");
const TypeFactory_1 = require("../TypeFactory");
const index_2 = require("./index");
const ExtensionPropertyParser_1 = require("./FlowNodeParsers/ActivityParsers/ExtensionPropertyParser");
function parseDefinitions(parsedObjectModel) {
    const definitions = parsedObjectModel[index_1.BpmnTags.CommonElement.Definitions];
    return convertToInternalObjectModel(definitions);
}
exports.parseDefinitions = parseDefinitions;
function convertToInternalObjectModel(parsedXml) {
    var _a;
    const definitions = createDefinitionBaseObject(parsedXml);
    const definitionId = definitions.id;
    try {
        definitions.collaboration = (0, index_2.parseCollaboration)(parsedXml);
        definitions.processes = (0, index_2.parseProcesses)(parsedXml);
        definitions.displayName = (_a = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('displayName', definitions.extensionElements.camundaExtensionProperties)) === null || _a === void 0 ? void 0 : _a.value;
        return definitions;
    }
    catch (error) {
        error.additionalInformation = {
            ...error.additionalInformation,
            definitionId: definitionId,
        };
        throw error;
    }
}
function createDefinitionBaseObject(parsedXml) {
    const basicDefinition = (0, TypeFactory_1.createObjectWithCommonProperties)(parsedXml, index_1.Model.Definitions);
    basicDefinition.xmlns = {
        bpmn: parsedXml[index_1.BpmnTags.XmlnsProperty.bpmn],
        bpmndi: parsedXml[index_1.BpmnTags.XmlnsProperty.bpmndi],
        camunda: parsedXml[index_1.BpmnTags.XmlnsProperty.camunda],
        dc: parsedXml[index_1.BpmnTags.XmlnsProperty.dc],
        di: parsedXml[index_1.BpmnTags.XmlnsProperty.di],
        xsi: parsedXml[index_1.BpmnTags.XmlnsProperty.xsi],
    };
    basicDefinition.targetNamespace = parsedXml.targetNamespace;
    basicDefinition.exporter = parsedXml.exporter;
    basicDefinition.exporterVersion = parsedXml.exporterVersion;
    return basicDefinition;
}
//# sourceMappingURL=DefinitionParser.js.map